import { API_CALLS } from "@/services/apis/index.js";

export default {
  getBrands() {
    return new Promise((resolve, reject) => {
      API_CALLS.getBrandsAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getBrand(context, id) {
    return new Promise((resolve, reject) => {
      API_CALLS.getBrandAPI(id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putBrand(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.putBrandAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postBrand(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.postBrandAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
